import React, { useEffect, useState } from "react";
import scrollTo from 'gatsby-plugin-smoothscroll';
import Layout from "../../components/layout";
import MainBanner from "../../components/industries-retail/page-main-banner-liquid-width";
import PageIntro from "../../components/common/templates/page-intro-section";
import IndustrySegments from "../../components/industries-retail/industry-segments";
import ThreeColSlider from "../../components/industries-retail/three-column-slider";
import IndustryRetailAI from "../../components/industries-retail/industry-retail-ai";
import IndustryRetailUseCase from "../../components/industries-retail/industry-retail-usecase";
import GridLayout from "../../components/industries-retail/grid-layout-section";
import CSSlider from "../../components/industries-retail/cs-slider";
import DigitalThinking from "../../components/industries-retail/industry-retail-digital-thinking";
import {
  mainBannerObj, pageIntroObj, industrySegmentsObj, threeColSliderObj, industryRetailAIObj, useCaseObj, gridlayoutObj, CSSliderObj, digitalThinkingobj
} from '../../components/industries-retail/industries-retail-constants';
import SEO, { webDevJSONLD } from '../../components/seo';
import { Helmet } from "react-helmet";
import InView from "react-intersection-observer";
import StickyCTA from "../../components/common/templates/sticky-cta-section";

function IndustriesRetailPage({ location }) {
  const [showVerticalNav, setShowVerticleNav] = useState(false);
  const [isLoaded, setisLoaded] = useState(false);
  const [overviewActive, setOverviewActive] = useState(false);
  const [segmentActive, setSegmentActive] = useState(false);
  const [productActive, setProductActive] = useState(false);
  const [retailAIActive, setRetailAIActive] = useState(false);
  const [solutionActive, setSolutionActive] = useState(false);
  const [caseStudiesActive, setCaseStudiesActive] = useState(false);
  const [insightActive, setInsightActive] = useState(false);

  {/*useEffect(()=>{
    if(overviewActive){
      setSegmentActive(false);
      setProductActive(false);
      setRetailAIActive(false);
      setSolutionActive(false);
      setCaseStudiesActive(false);
      setInsightActive(false);
    }
    if(segmentActive){
      setOverviewActive(false);
      setProductActive(false);
      setRetailAIActive(false);
      setSolutionActive(false);
      setCaseStudiesActive(false);
      setInsightActive(false);
    }
    if(productActive){
      setOverviewActive(false);
      setSegmentActive(false);
      setRetailAIActive(false);
      setSolutionActive(false);
      setCaseStudiesActive(false);
      setInsightActive(false);
    }
    if(retailAIActive){
      setOverviewActive(false);
      setSegmentActive(false);
      setProductActive(false);
      setSolutionActive(false);
      setCaseStudiesActive(false);
      setInsightActive(false);
    }
    if(solutionActive){
      setOverviewActive(false);
      setSegmentActive(false);
      setProductActive(false);
      setRetailAIActive(false);
      setCaseStudiesActive(false);
      setInsightActive(false);
    }
    if(caseStudiesActive){
      setOverviewActive(false);
      setSegmentActive(false);
      setProductActive(false);
      setRetailAIActive(false);
      setSolutionActive(false);
      setInsightActive(false);
    }
    if(insightActive){
      setOverviewActive(false);
      setSegmentActive(false);
      setProductActive(false);
      setRetailAIActive(false);
      setSolutionActive(false);
      setCaseStudiesActive(false);
    }
  })
 */}
  const verticleNav = (
    <ul className="col vertical-navigation-list">
      <li className={`${overviewActive ? 'active' : ''}`}>
        <div style={{ color: "#888888", cursor: "pointer" }} onClick={() => scrollTo('#overview')}>Overview</div>
      </li>
      <li className={`${segmentActive ? 'active' : ''}`} >
        <div style={{ color: "#888888", cursor: "pointer" }} onClick={() => scrollTo('#industry-segments')}>Segments</div>
      </li>
      <li className={`${productActive ? 'active' : ''}`}>
        <div style={{ color: "#888888", cursor: "pointer" }} onClick={() => scrollTo('#retail-product')}>Products</div>
      </li>
      <li className={`${retailAIActive ? 'active' : ''}`}>
        <div style={{ color: "#888888", cursor: "pointer" }} onClick={() => scrollTo('#retail-ai')}>Retail AI</div>
      </li>
      <li className={`${solutionActive ? 'active' : ''}`}>
        <div style={{ color: "#888888", cursor: "pointer" }} onClick={() => scrollTo('#retail-solution')}>Solutions</div>
      </li>
      <li className={`${caseStudiesActive ? 'active' : ''}`}>
        <div style={{ color: "#888888", cursor: "pointer" }} onClick={() => scrollTo('#retail-case-studies')}>Case Studies</div>
      </li>
      <li className={`${insightActive ? 'active' : ''}`}>
        <div style={{ color: "#888888", cursor: "pointer" }} onClick={() => scrollTo('#retail-thinking')}>Insights</div>
      </li>
    </ul>
  );

  return (
    <div onLoad={() => { setisLoaded(true); }}>
      <Layout addBodyClass={"industries-retail transparent-header " + (showVerticalNav ? 'verticle-navigation-active' : '')}
        footerFormType="basic" verticleNav={verticleNav} footerData={{ footerText: "web" }}>
        <Helmet>
          <script type="application/ld+json">{webDevJSONLD}</script>
        </Helmet>
        <SEO description="Digital retail services, cloud retail solutions, products & platforms from Rapidops help retailers lead the digital disruption driven by consumers."
          meta={[{ name: "charSet", content: "utf-8" }]}
          title="Retail Consultant | Retail Digital Transformation & Innovation Services" />
        <MainBanner data={mainBannerObj} setShowVerticleNav={setShowVerticleNav} />
        <InView onChange={(inView)=>setOverviewActive(inView)} threshold={[0.3]}>
          <PageIntro data={pageIntroObj} id="overview" isLoaded={isLoaded} />
        </InView>
        <InView onChange={(inView)=>setSegmentActive(inView)} threshold={[0.3]}>
          <IndustrySegments data={industrySegmentsObj} id="industry-segments" isLoaded={isLoaded} />
        </InView>
        <InView onChange={(inView)=>setProductActive(inView)} threshold={[0.3]}>
          <ThreeColSlider data={threeColSliderObj} id="retail-product" isLoaded={isLoaded} location={location.pathname} />
        </InView>
        <InView onChange={(inView)=>setRetailAIActive(inView)} threshold={[0.3]}>
          <IndustryRetailAI data={industryRetailAIObj} id="retail-ai" isLoaded={isLoaded} location={location.pathname} />
        </InView>
        <InView onChange={(inView)=>setSolutionActive(inView)} threshold={[0.3]}>
          <IndustryRetailUseCase data={useCaseObj} id="retail-solution" isLoaded={isLoaded} location={location.pathname} />
        </InView>
        <GridLayout data={gridlayoutObj} id="retail-product-grid" isLoaded={isLoaded} />
        <InView onChange={(inView)=>setCaseStudiesActive(inView)} threshold={[0.3]}>
          <CSSlider data={CSSliderObj} id="retail-case-studies" isLoaded={isLoaded} />
        </InView>
        <InView onChange={(inView)=>setInsightActive(inView)} threshold={[0.3]}>
          <DigitalThinking data={digitalThinkingobj} id="retail-thinking" isLoaded={isLoaded} />
        </InView>
        {/* <StickyCTA /> */}
      </Layout>
    </div>
  );
}

export default IndustriesRetailPage;